var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
import React from "react";
import classNames from "classnames";
import { CoverMedia } from "../cover/Media";
import { bannerCls, bannerGradientCls, bannerSizeSmallCls, bannerSizeMediumCls, bannerSizeLargeCls, bannerMediaCls, bannerContainerCls } from "./Banner.less";
var SIZE_TO_CLASSNAME = {
  small: bannerSizeSmallCls,
  medium: bannerSizeMediumCls,
  large: bannerSizeLargeCls
};
var DEFAULT_SIZE = Object.keys(SIZE_TO_CLASSNAME)[0];
function Banner(_ref) {
  var className = _ref.className, _ref$size = _ref.size, size = _ref$size === void 0 ? DEFAULT_SIZE : _ref$size, _ref$gradient = _ref.gradient, gradient = _ref$gradient === void 0 ? false : _ref$gradient, media = _ref.media, _ref$children = _ref.children, children = _ref$children === void 0 ? null : _ref$children;
  return /* @__PURE__ */ React.createElement("div", {
    className: classNames(bannerCls, size && SIZE_TO_CLASSNAME[size], gradient && bannerGradientCls, className)
  }, /* @__PURE__ */ React.createElement(CoverMedia, {
    className: bannerMediaCls
  }, media), children && /* @__PURE__ */ React.createElement("div", {
    className: bannerContainerCls
  }, children));
}
__name(Banner, "Banner");
export {
  Banner
};
